import * as React from "react";
import { ZoomSlidingBox, ZoomSlidingCardBox } from "./styles.index";
import { LinkTargetType } from "../../../services/playground";
import ImageView from "../../../components/SmartImage";
const CubeBannerBase = (props) => {
    const { elements, positionId, placeholderBg, aTarget = LinkTargetType.Blank } = props;
    return (React.createElement(ZoomSlidingBox, { id: positionId }, elements.map((element, i) => (React.createElement(ZoomSlidingCardBox, Object.assign({ key: i, onClick: e => {
            if (!element.link) {
                e.preventDefault();
            }
        } }, (element.link ? { href: element.link, target: aTarget } : {})),
        React.createElement(ImageView, { src: element.img, online: props.online, key: i, style: {}, placeholder: placeholderBg }))))));
};
export default CubeBannerBase;
